export default {
  "ALLTYPES": "",
  "AccountHierarchySettings": {
    "account": "",
    "dialogTitle": "",
    "directSuperiorAccount": "",
    "directSuperiorEmail": "",
    "directSuperiorName": "",
    "email": "",
    "employeeAccount": "",
    "employeeName": "",
    "isThereASkipLevelLeader": "",
    "name": "",
    "no": "",
    "searchPlaceholder": "",
    "skipLevelLeaderAccount": "",
    "skipLevelLeaderEmail": "",
    "skipLevelLeaderName": "",
    "yes": ""
  },
  "AddCover": "",
  "AddData": "",
  "AddVideo": "",
  "AddtoEmail": "",
  "Admin": {
    "AP": "",
    "AllocateAmount": "",
    "ArchitectureArea": "",
    "BWC": "",
    "ManufacturingPlant": "",
    "NOL": "",
    "OFTHEDIV": "",
    "OTF": "",
    "PONo": "",
    "POSettlement": "",
    "POType": "",
    "SAPPI": "",
    "SAPStatus": "",
    "TL": "",
    "account": "",
    "active": "",
    "add": "",
    "addAccount": "",
    "addOnOption": "",
    "addOnOption1": "",
    "addRelationship": "",
    "addtoPo": "",
    "all": "",
    "amountSum": "",
    "amountTotal": "",
    "ariA": "",
    "arms": "",
    "arrangementType": "",
    "authorizedSignature": "",
    "backs": "",
    "bd": "",
    "businessEmail": "",
    "buyer": "",
    "cabinetType": "",
    "cancel": "",
    "categories": "",
    "category": "",
    "checkAll": "",
    "china": "",
    "chinavietnam": "",
    "cis": "",
    "clear": "",
    "closeAll": "",
    "closeOther": "",
    "closing": "",
    "code": "",
    "color": "",
    "completeSetNumber": "",
    "component": "",
    "confirm": "",
    "confirmDelete": "",
    "confirmInheritanceMessage": "",
    "container": "",
    "containerCaculation": "",
    "containerVolumeUtilizationRate": "",
    "content": "",
    "continue": "",
    "copy": "",
    "coverGrade": "",
    "createdAccount": "",
    "cube": "",
    "cubeSum": "",
    "cubeTotal": "",
    "cubes": "",
    "cubesTotal": "",
    "customerEmail": "",
    "customized": "",
    "deleteInfo": "",
    "depth": "",
    "description": "",
    "disable": "",
    "discountAmount": "",
    "discountRate": "",
    "edit": "",
    "editAccount": "",
    "effective": "",
    "email": "",
    "emailEnter": "",
    "emailStatus": "",
    "enable": "",
    "errorInfo": "",
    "exportPO": "",
    "failToSend": "",
    "fax": "",
    "features": "",
    "fp": "",
    "freight": "",
    "grade": "",
    "group": "",
    "height": "",
    "image": "",
    "inactive": "",
    "index": "",
    "inheritor": "",
    "isUsed": "",
    "leading": "",
    "leather": "",
    "length": "",
    "loadability": "",
    "loginlog": "",
    "lwh": "",
    "marketModel": "",
    "marketNewModel": "",
    "material": "",
    "mechanisms": "",
    "mes1": "",
    "mexico": "",
    "models": "",
    "motion": "",
    "motionType": "",
    "name": "",
    "nationality": "",
    "networkError": "",
    "no": "",
    "notSigned": "",
    "offShelf": "",
    "op": "",
    "ot": "",
    "package": "",
    "packageMethod": "",
    "packageSize": "",
    "params": "",
    "pieceCount": "",
    "pleaseEnter": "",
    "pleaseEnterQTY": "",
    "pleaseSelect": "",
    "pleaseSelectAvaliablePO": "",
    "pleaseSelectPO": "",
    "poNo": "",
    "position": "",
    "price": "",
    "priceRange": "",
    "promptInfo": "",
    "provenance": "",
    "pts": "",
    "qsInventoryAddCarError": "",
    "quantityOfGoods": "",
    "rai": "",
    "readyDate": "",
    "relevantP": "",
    "role": "",
    "salesDiscount": "",
    "salesPrice": "",
    "save": "",
    "seats": "",
    "seats2": "",
    "selectiveColor": "",
    "sendEmail": "",
    "sendPo": "",
    "sendToSap": "",
    "sent": "",
    "sentSuccessfully": "",
    "sentence": "",
    "setQuantity": "",
    "settingUp": "",
    "settlementPO": "",
    "settlementPOTips": "",
    "signatureVerification": "",
    "skin": "",
    "skuType": "",
    "spec": "",
    "status": "",
    "styles": "",
    "subtotal": "",
    "tips": "",
    "total": "",
    "totalCargoVolume": "",
    "totalOrderAmount": "",
    "trait": "",
    "type": "",
    "uniqueArrangment": "",
    "unit": "",
    "update": "",
    "userAccount": "",
    "userCode": "",
    "vietnam": "",
    "view": "",
    "weight": "",
    "width": "",
    "yes": ""
  },
  "AmountIsNotANumber": "",
  "BatchImport": "",
  "Brand": "",
  "CatalogPages": "",
  "ClientName": "",
  "Closeup": "",
  "Commitments": {
    "AddExReservation": "",
    "AddMarket": "",
    "AddNewCustomerData": "",
    "AnnualTurnover": "",
    "ArrangementMaintainTemplate": "",
    "Arrangements": "",
    "BonusMonth": "",
    "Color": "",
    "CommitmentConfirm": "",
    "CommitmentQTY": "",
    "CommitmentsList": "",
    "Company": "",
    "Confirm": "",
    "ConfirmedOrderAMT": "",
    "ConfirmedOrderQTY": "",
    "Country": "",
    "Covers": "",
    "Customer": "",
    "CustomerConfirmedDate": "",
    "CustomerName": "",
    "CustomerType": "",
    "CustomersToInvite": "",
    "DescCombination": "",
    "Describe": "",
    "Division": "",
    "Edit": "",
    "Email": "",
    "ExhibitionBonusDistributionTemplate": "",
    "ExhibitionBonusStylesTemplate": "",
    "IMIC": "",
    "IMICT": "",
    "LineItemNumber": "",
    "MaintainTemplate": "",
    "Maintainer": "",
    "MaintenanceDate": "",
    "Market": "",
    "MarketNameCN": "",
    "MarketNameEN": "",
    "MarketTime": "",
    "MarketsEndDate": "",
    "MarketsList": "",
    "MarketsName": "",
    "MarketsStartDate": "",
    "MaterialCode": "",
    "MaterialNumber": "",
    "Nationality": "",
    "NewCustomer": "",
    "NewCustomers": "",
    "NewModelLaunchDate": "",
    "NewModelOrigin": "",
    "NewReGularCustomer": "",
    "NumberOfOrders": "",
    "OldModelReExhibit": "",
    "OrderAmount": "",
    "OrderCutofftime": "",
    "OrderPlaceDate": "",
    "OverdueDays": "",
    "PODate": "",
    "POOrderNumber": "",
    "ReasonForNotOrdering": "",
    "RegularCustomers": "",
    "RequestedReadyDate": "",
    "Sales": "",
    "SalesDepartment": "",
    "ShippingCutoffTime": "",
    "StartDate": "",
    "StoreNumber": "",
    "StyleSpecifications": "",
    "Title": "",
    "TotalAmount": "",
    "VPSales": "",
    "ViaitingTimeLately": "",
    "actualFactoryDate": "",
    "actualVisitMarketTime": "",
    "addAppointment": "",
    "agree": "",
    "appointmentApprovalProcess": "",
    "appointmentList": "",
    "approval": "",
    "approvalComments": "",
    "approvalList": "",
    "approvalStatus": "",
    "approved": "",
    "approverComments": "",
    "area": "",
    "clientsToInvite": "",
    "companyName": "",
    "countryState": "",
    "countryStates": "",
    "create": "",
    "detail": "",
    "endDate": "",
    "exhibitionCalendar": "",
    "exhibitionDepartment": "",
    "expectedFactoryDate": "",
    "exportMes": "",
    "footerTips": "",
    "generalManagerApproval": "",
    "hasBeenInvited": "",
    "id": "",
    "mUnit": "",
    "marketArrivialConfirm": "",
    "marketRanking": "",
    "meetingContent": "",
    "mwSales": "",
    "nationalitys": "",
    "nextClientVisitDate": "",
    "officeExport": "",
    "online": "",
    "partyAttendanceNum": "",
    "pendingApproval": "",
    "pendingReview": "",
    "pendingSubmission": "",
    "percentage": "",
    "quantity": "",
    "recall": "",
    "reject": "",
    "reject1": "",
    "rejected": "",
    "remark": "",
    "retailer": "",
    "reviewComments": "",
    "saleDeptInp": "",
    "selectCountry": "",
    "selectCustomerName": "",
    "sofaSales": "",
    "state": "",
    "status": "",
    "submitForApproval": "",
    "toBeInvited": "",
    "updateDate": "",
    "view": "",
    "viewExhibitionCalendar": "",
    "vpSalesExport": "",
    "whetherAttendParty": "",
    "wholesaler": "",
    "salesAnalysis": ""
  },
  "Competing": {
    "formlable0": "",
    "formlable1": "",
    "formlable2": "",
    "formlable3": "",
    "formlable4": "",
    "formlable5": "",
    "formlable6": "",
    "tabTitle1": "",
    "tabTitle2": "",
    "tabTitle3": ""
  },
  "CompetitiveProductAnalysisDataListPage": {
    "addCompany": "",
    "addCustomer": "",
    "cd": "",
    "competitorNum": "",
    "country": "",
    "customerName": "",
    "editCompany": "",
    "editCustomer": "",
    "exportCompetingProducts": "",
    "handle": "",
    "inset": "",
    "lastEditDate": "",
    "recentUploadTime": "",
    "sales": "",
    "save": "",
    "uploadDate": "",
    "uploader": "",
    "view": "",
    "vp": ""
  },
  "CompetitiveProductAnalysisPage": {
    "categoryList": "",
    "collaborated": "",
    "gradeList": "",
    "materialList": "",
    "nonCollaborated": "",
    "priceBandList": "",
    "selectTips": "",
    "table": {
      "competitorCustomersNotUploaded": "",
      "competitorCustomersUploaded": "",
      "division": "",
      "handle": "",
      "insert": "",
      "newRate": "",
      "title1": "",
      "title2": "",
      "title3": "",
      "title4": "",
      "totalCustomerCount": "",
      "uploadRate": "",
      "view": ""
    },
    "to": "",
    "tup": "",
    "tur": "",
    "viewUploadedCompetitiveProductInformation": ""
  },
  "CompetitiveProductAnalysisStylePage": {
    "Currency": "",
    "add": "",
    "addFrame": "",
    "arrangementType": "",
    "category": "",
    "classification": "",
    "clickUpload": "",
    "column": "",
    "company": "",
    "cover": "",
    "covers": "",
    "customer": "",
    "delete": "",
    "dimensionType": "",
    "displaySection": "",
    "dragUploadText": "",
    "exhibitionPrice": "",
    "features": "",
    "filterPlaceholder": "",
    "floorDisplayNumber": "",
    "fobPrice": "",
    "function": "",
    "image": "",
    "images": "",
    "leve": "",
    "model": "",
    "newFunctions": "",
    "no": "",
    "notes": "",
    "onlineOnly": "",
    "pdc": "",
    "price": "",
    "priceRange": "",
    "productName": "",
    "salesType": "",
    "search": "",
    "size": "",
    "tableSection": "",
    "type": "",
    "types": "",
    "update": "",
    "uploadExceedLimit": "",
    "uploadFailed": "",
    "uploadImageFormatError": "",
    "uploadImageSizeError": "",
    "uploadTip": "",
    "vendor": "",
    "yes": ""
  },
  "ConfirmOperation": "",
  "ContainerDimensions": {
    "allowed": "",
    "dialogTitle": "",
    "flatPosition": "",
    "flatWithHorizontalRotation": "",
    "height": "",
    "length": "",
    "materialNo": "",
    "mixedStackingAllowed": "",
    "no": "",
    "notAllowed": "",
    "onSidePosition": "",
    "onSideWithHorizontalRotation": "",
    "packageSize": "",
    "permitted": "",
    "placementMethod": "",
    "stackingTiers": "",
    "tips": "",
    "uprightPosition": "",
    "uprightWithHorizontalRotation": "",
    "width": ""
  },
  "CopyLinks": "",
  "CountryNotselected": "",
  "Customer": {
    "AddNewCustomerData": "",
    "ApproxFurnitureSales": "",
    "CustomerAnualSales": "",
    "CustomerInformationion": "",
    "CustomerManagement": "",
    "LocalRanking": "",
    "ManWahSales": "",
    "StoreNumber": "",
    "TargetSales": "",
    "ViaitingTimeLately": "",
    "level": "",
    "state": ""
  },
  "CustomerPage": {
    "AccountReceivable": "",
    "AddBusinessCard": "",
    "AddCustomer": "",
    "AmountReceivable": "",
    "Attachment": "",
    "CNCSR": "",
    "CREDITTRADEREFERENCES": "",
    "CType": "",
    "City": "",
    "Cname": "",
    "Cnumber": "",
    "CompensationratioofRejection": "",
    "Confirm": "",
    "Country": "",
    "Credit": "",
    "CreditLine": "",
    "CreditPeriodDays": "",
    "CustomerDet": {
      "thTitle1": "",
      "thTitle10": "",
      "thTitle11": "",
      "thTitle12": "",
      "thTitle13": "",
      "thTitle14": "",
      "thTitle14s": "",
      "thTitle15": "",
      "thTitle16": "",
      "thTitle17": "",
      "thTitle18": "",
      "thTitle19": "",
      "thTitle2": "",
      "thTitle20": "",
      "thTitle21": "",
      "thTitle22": "",
      "thTitle23": "",
      "thTitle24": "",
      "thTitle25": "",
      "thTitle26": "",
      "thTitle27": "",
      "thTitle28": "",
      "thTitle29": "",
      "thTitle3": "",
      "thTitle30": "",
      "thTitle31": "",
      "thTitle32": "",
      "thTitle33": "",
      "thTitle34": "",
      "thTitle35": "",
      "thTitle36": "",
      "thTitle37": "",
      "thTitle38": "",
      "thTitle39": "",
      "thTitle4": "",
      "thTitle40": "",
      "thTitle5": "",
      "thTitle6": "",
      "thTitle7": "",
      "thTitle8": "",
      "thTitle9": "",
      "tnouo": ""
    },
    "EffectiveDate": "",
    "ExpiryDate": "",
    "Fabric": "",
    "InCompany": "",
    "InsuranceCompany": "",
    "LineUp": {
      "addFloorSlot": "",
      "amount": "",
      "blankets": "",
      "budget": "",
      "coverCode": "",
      "coverName": "",
      "floorDisplays": "",
      "fobPrice": "",
      "growthRate": "",
      "introductionDate": "",
      "level": "",
      "model": "",
      "openOrders": "",
      "picture": "",
      "previousYearJanDec": "",
      "salesYTD": "",
      "samePeriodSalesPreviousYear": "",
      "sku": "",
      "spec": "",
      "status": "",
      "year": ""
    },
    "MWVP": "",
    "MainImage": "",
    "OverdueAmount": "",
    "PoCode": "",
    "RegionalVP": "",
    "Remark": "",
    "STP": "",
    "SalesRepresentive": "",
    "SkuClass": "",
    "Sponge": "",
    "TOT": "",
    "VNCSR": "",
    "VPAssistant": "",
    "Variation": "",
    "addr": "",
    "comments": "",
    "mainPhoto": "",
    "modelTye": "",
    "no": "",
    "paymentTerm": "",
    "price": "",
    "priceSecond": "",
    "prices": "",
    "quty": "",
    "rate": "",
    "saleDept": "",
    "sato": "",
    "tabTitle1": "",
    "tabTitle2": "",
    "tabTitle3": "",
    "tabTitle4": "",
    "tabTitle5": "",
    "tabTitle6": "",
    "tb1": "",
    "tel": "",
    "tips": "",
    "tipsInfo": "",
    "wip": "",
    "yes": ""
  },
  "Date": "",
  "DepPleaseSelectBrand": "",
  "DepPleaseSelectFactory": "",
  "Documents": {
    "filetitle": "",
    "uptime": "",
    "usDp": ""
  },
  "Download": "",
  "Downloads": "",
  "EditCover": "",
  "EditVideo": "",
  "EndDate": "",
  "ExReservationInvitationSummary": {
    "achievementRate": "",
    "division": "",
    "invitationAchievementRate": "",
    "numberOfClients": "",
    "numberOfClientsDecliningAttendance": "",
    "numberOfClientsInvited": "",
    "numberOfCollaboratedClients": "",
    "numberOfNonCollaboratedClients": "",
    "plannedInvitationRate": "",
    "plannedInvitationRateForCurrentExhibition": "",
    "plannedNumberOfClientsToInvite": "",
    "title": "",
    "totalInvitationsCompleted": "",
    "totalNumberOfClients": "",
    "totalPlannedInvitations": "",
    "LYIC": "",
    "YR": ""
  },
  "FileIsNull": "",
  "Firstlevelreport": "",
  "Hello": "",
  "HiRes": "",
  "Home": {
    "Department": "",
    "Isitoverdue": "",
    "OverdueAmount": "",
    "SaleAmount": "",
    "charTitle1": "",
    "charTitle2": "",
    "charTitle3": "",
    "charTitle4": "",
    "charTitle5": "",
    "charTitle6": "",
    "charTitle7": "",
    "charTitle8": "",
    "color": "",
    "lastYear": "",
    "money": "",
    "more": "",
    "radio": "",
    "tbTitle1": "",
    "tbTitle2": "",
    "tbTitle3": "",
    "tbTitle4": "",
    "tbTitle5": "",
    "thisYear": ""
  },
  "ImagesAndVideo": {
    "Body": "",
    "Clear": "",
    "EmailTo": "",
    "SendEmail": "",
    "Subject": "",
    "remove": "",
    "type": ""
  },
  "InventoryPlatform": {
    "ADOL": "",
    "ALT": "",
    "APAD": "",
    "APD": "",
    "ASD": "",
    "ActualReadyDate": "",
    "CCD": "",
    "Container": "",
    "CustomerInventory": "",
    "CustomerInventoryInfoTpl": "",
    "DeliverNo": "",
    "ETA": "",
    "ETD": "",
    "EstReadyDate": "",
    "FCD": "",
    "FCN": "",
    "IHOQ": "",
    "ImportSuccessful": "",
    "InProduction": "",
    "IncorrectDownload": "",
    "LoadingDate": "",
    "MeterialAvailableStock": "",
    "MeterialInTransit": "",
    "OAR": "",
    "OrderQuantity": "",
    "PAD": "",
    "PAFC": "",
    "PCD": "",
    "MOD": "",
    "POTD": "",
    "PCFT": "",
    "UPD": "",
    "PD": "",
    "PO": "",
    "ProductInStock": "",
    "ProductInTransit": "",
    "ProductInfo": "",
    "ProductInfoTpl": "",
    "ReadyDate": "",
    "ReplenishmentQTY": "",
    "RequestReadyDate": "",
    "SRD": "",
    "SRL": "",
    "ShippedQuantity": "",
    "StockQTY": "",
    "StockQTYs": "",
    "TAPOS": "",
    "ThisWeekInvoice": "",
    "UnProduced": "",
    "WeekEndTime": "",
    "WeekStartTime": "",
    "adtips": "",
    "basicInfo": "",
    "cancel": "",
    "categoryId": "",
    "changeDays": "",
    "color": "",
    "confirm": "",
    "containerNumber": "",
    "createTime": "",
    "createUser": "",
    "customer": "",
    "customerCode": "",
    "customerDataTpl": "",
    "customerName": "",
    "customerPo": "",
    "customerSKU": "",
    "deleteConfirm": "",
    "deleteSuccessful": "",
    "disable": "",
    "enable": "",
    "endMonth": "",
    "eta": "",
    "etd": "",
    "fabricNumber": "",
    "features": "",
    "file": "",
    "item": "",
    "model": "",
    "mwSKU": "",
    "numberOfStore": "",
    "operate": "",
    "pleaseSelectData": "",
    "po": "",
    "prompt": "",
    "remark": "",
    "save": "",
    "saveSuccess": "",
    "seq": "",
    "shipTo": "",
    "sku": "",
    "startMonth": "",
    "status": "",
    "storeFloorSampleQTY": "",
    "supplier": "",
    "undeliveriedQTY": "",
    "uploadTip1": "",
    "uploadTip2": "",
    "weekDate": ""
  },
  "Large": "",
  "LifeStyle": "",
  "MainPushStyleSalesRanking": {
    "category": "",
    "categoryRanking": "",
    "color": "",
    "cumulativeNetSales": "",
    "customer": "",
    "countryName": "",
    "department": "",
    "fandm": "",
    "ferth": "",
    "fobPrice": "",
    "level": "",
    "levelRanking": "",
    "mark": "",
    "model": "",
    "netSales": "",
    "numbersOfDisplay": "",
    "orderQuantityInIheNext3months": "",
    "picture": "",
    "recommendedStatus": "",
    "running": "",
    "type": ""
  },
  "Medium": "",
  "ModelsDet": {
    "title": ""
  },
  "MonthRange": "",
  "Normal": "",
  "OrderAverageDeliveryTime": {
    "cargoState": "",
    "customerName": "",
    "exportFileName": "",
    "no": "",
    "orderA2C": "",
    "orderC2D": "",
    "orderCompleted2Delivery": "",
    "orderCompleted2Vanning": "",
    "orderCreateTime": "",
    "orderD2Completed": "",
    "orderOccupationTime": "",
    "orderQuantity": "",
    "shipped": "",
    "total": "",
    "unshipped": "",
    "vpSales": ""
  },
  "OrderDeliveryTimeOverviewOrDetail": {
    "create": "",
    "currentStatus": "",
    "custom": "",
    "acStatus": "",
    "cycleConditions": "",
    "day": "",
    "deliveryOrNot": "",
    "figure1": "",
    "figure2": "",
    "firstDeliveryDate": "",
    "hasBeenShipped": "",
    "haveBeenCompleted": "",
    "haveSigned": "",
    "inTheProduction": "",
    "installedCabinet": "",
    "invalidDateRange": "",
    "month": "",
    "orderA2C": "",
    "orderA2Delivery": "",
    "orderC2D": "",
    "orderCompleted2Delivery": "",
    "orderCompleted2Vanning": "",
    "orderCreareDate": "",
    "orderCreateTime": "",
    "orderD2Completed": "",
    "orderD2Delivery": "",
    "orderD2ExpectedCompleted": "",
    "orderId": "",
    "orderOccupationTime": "",
    "reviewDateD": "",
    "siteValidation": "",
    "title1": "",
    "title2": "",
    "total": "",
    "totalDeliveryTime": ""
  },
  "OrderInput": "",
  "OrderInputDetailList": "",
  "OrderIntake": {
    "TooC": "",
    "styleStatisticalDetail": "",
    "styleCode": "",
    "bookDate": "",
    "color": "",
    "currentMonthDeliveries": "",
    "customerName": "",
    "customerOrderNumber": "",
    "lastMonthShipments": "",
    "monthDate": "",
    "mp": "",
    "numberOfDisplaySetups": "",
    "occupancyDate": "",
    "styleOrderInfo": "",
    "styleInfo": "",
    "orderInfo": "",
    "orderNum": "",
    "ordersReceivedLastMonth": "",
    "quantity": "",
    "salesOrder": "",
    "spec": "",
    "status": "",
    "style": "",
    "subtotal": "",
    "total": "",
    "unitPrice": "",
    "vpSales": "",
    "noSo": "",
    "noSoInfo": ""
  },
  "OrderPage": {
    "Destination": "",
    "Order": "",
    "OrderDate": "",
    "PONO": "",
    "PaymentTerms": "",
    "Period": "",
    "indexTb": {
      "t1": "",
      "t2": "",
      "t3": "",
      "t4": "",
      "t5": "",
      "t6": "",
      "t7": "",
      "t8": "",
      "t9": ""
    },
    "orderlist": {
      "th1": "",
      "th10": "",
      "th11": "",
      "th12": "",
      "th13": "",
      "th14": "",
      "th15": "",
      "th16": "",
      "th17": "",
      "th2": "",
      "th3": "",
      "th4": "",
      "th5": "",
      "th6": "",
      "th7": "",
      "th8": "",
      "th9": ""
    },
    "payTerms": "",
    "tabTitle1": "",
    "tabTitle2": "",
    "tabTitle3": "",
    "tabTitle4": "",
    "tabTitle5": "",
    "tabTitle6": "",
    "tabTitle7": "",
    "thead": {
      "title1": "",
      "title2": "",
      "title3": "",
      "title4": "",
      "title5": ""
    }
  },
  "Performance": {
    "Acutal1": "",
    "Acutal2": "",
    "BIT": "",
    "Budget": "",
    "Division1": "",
    "Division2": "",
    "Division3": "",
    "ESAPC": "",
    "cabinet": "",
    "tabTitle0": "",
    "tabTitle1": "",
    "tabTitle10": "",
    "tabTitle11": "",
    "tabTitle2": "",
    "tabTitle3": "",
    "tabTitle4": "",
    "tabTitle5": "",
    "tabTitle6": "",
    "tabTitle7": "",
    "tabTitle8": "",
    "tabTitle9": "",
    "vpassistant": ""
  },
  "PleaseConfirmPassword": "",
  "PleaseEnter": "",
  "PleaseEnterNewPassword": "",
  "PleaseInput": "",
  "PleaseInputBudge": "",
  "PleaseInputColor": "",
  "PleaseInputCubes": "",
  "PleaseInputDepth": "",
  "PleaseInputDescription": "",
  "PleaseInputLength": "",
  "PleaseInputPrice": "",
  "PleaseInputSku": "",
  "PleaseInputTitle": "",
  "PleaseInputcovers": "",
  "PleaseSelect": "",
  "PleaseSelectArrangements": "",
  "PleaseSelectModel": "",
  "PleaseSelectTheDownloadMethod": "",
  "PleaseSelectType": "",
  "Receivables": "",
  "Report": {
    "AllTypes": "",
    "PleaseEnterCodeOrName": "",
    "PleaseEnterNameSearch": ""
  },
  "Secondaryreport": "",
  "SelectFile": "",
  "SendContentViaEmail": "",
  "ShippedDetailList": "",
  "ShippedOrderSummary": "",
  "Small": "",
  "StartDate": "",
  "Temporarily": "",
  "Tips": "",
  "ToDoReminder": {
    "competingProductsRelated": "",
    "marketsRelated": "",
    "orderRelated": "",
    "otherRelated": ""
  },
  "ToSendToMultipleEmails": "",
  "TravelList": {
    "byway": ""
  },
  "UploadPicturesCaninJPGformat": "",
  "Videos": "",
  "VisitTime": "",
  "addCompetitors": {
    "PleaseInputAmount": "",
    "PleaseInputCustomerDescribe": "",
    "PleaseInputDetails": "",
    "PleaseInputTitle": "",
    "PleaseInputUserName": "",
    "selectdate": ""
  },
  "addSuccess": "",
  "addTravel": {
    "CustomerDetailsP": "",
    "CustomerLocation": "",
    "CustomerName": "",
    "Opportunity": "",
    "PleaseInputContacts": ""
  },
  "competingGoodsInfo": {
    "Commitments": "",
    "title1": "",
    "title2": "",
    "title3": "",
    "title4": "",
    "title5": "",
    "title6": "",
    "title7": ""
  },
  "confirm": "",
  "confirmError": "",
  "confirmPassword": "",
  "covers": {
    "coverGroup": "",
    "coverName": "",
    "coverNumber": "",
    "coverType": ""
  },
  "dash": {
    "Year": ""
  },
  "editPricelist": "",
  "factory": "",
  "firstLogin": "",
  "formlabel": {
    "Count": "",
    "Department": "",
    "Month": "",
    "Quarter": "",
    "ResetBtn": "",
    "ReturnBtn": "",
    "SearchBtn": "",
    "Selectfile": "",
    "SingleBtn1": "",
    "SingleBtn2": "",
    "SingleCount": "",
    "SingleCounts": "",
    "Year": "",
    "addBtn": "",
    "allExport": "",
    "cancel": "",
    "classify": "",
    "createCommitment": "",
    "createdDate": "",
    "delete": "",
    "batchDelete": "",
    "download": "",
    "downloadTemplate": "",
    "downloadbtn": "",
    "editBtn": "",
    "export": "",
    "exportCountSheet": "",
    "exportData": "",
    "lineup": "",
    "exportDataAll": "",
    "exportDataAllT": "",
    "exportDataSecond": "",
    "exportDataThree": "",
    "exportDatas": "",
    "exportNewData": "",
    "exportExcel": "",
    "exportExcel1": "",
    "exportExcel2": "",
    "exportPdf": "",
    "exportType": "",
    "handle": "",
    "import": "",
    "keyword": "",
    "label1": "",
    "label2": "",
    "label3": "",
    "label4": "",
    "label5": "",
    "label6": "",
    "label7": "",
    "label8": "",
    "partExport": "",
    "submitBtn": "",
    "title": "",
    "updateDate": "",
    "upload": "",
    "exportAnsis": ""
  },
  "level": "",
  "loading": "",
  "logout": "",
  "logoutConfirm": "",
  "menu": {
    "menu_title15": "",
    "menu_title16": "",
    "menu_title17": "",
    "menu_title18": ""
  },
  "menus": {
    "Account": "",
    "AccountHierarchySettings": "",
    "Admin": "",
    "Arms": "",
    "Arrangements": "",
    "Backs": "",
    "Catalog": "",
    "Categories": "",
    "Commitments": "",
    "CompetitiveProductAnalysis": "",
    "CompetitiveProductAnalysisDataList": "",
    "Competitorslist": "",
    "ConfirmOrderDetails": "",
    "ContainerDimensions": "",
    "ContentRelated": "",
    "Cover": "",
    "dayawanCover": "",
    "vietnamCover": "",
    "CoverFeature": "",
    "Covers": "",
    "CoversGrades": "",
    "CoversGroups": "",
    "CoversRelated": "",
    "Customer": "",
    "CustomerManagement": "",
    "CustomerSalesInfo": "",
    "DFSEDIInvolce": "",
    "Documents": "",
    "ExReservation": "",
    "ExReservationInvitationSummary": "",
    "ExReservationInvitationSummaryForBusiness": "",
    "ExReservationTabs": "",
    "ExhibitionBonusDistribution": "",
    "ExhibitionBonusStyles": "",
    "ExportDeliveryReport": "",
    "Features": "",
    "FinanceReports": "",
    "FollowUpSituationTable": "",
    "Frames": "",
    "InventoryPlatform": "",
    "InventoryPlatformCustomerData": "",
    "InventoryPlatformCustomerDataNew": "",
    "InventoryPlatformProductInfoConfig": "",
    "InventoryPlatformSharingReport": "",
    "InventoryReport": "",
    "LeaderboardReport": "",
    "MainPushStyleSalesRanking": "",
    "MainPushStyleSalesRankingTwo": "",
    "MarketNewModelBonusReport": "",
    "Mechanisms": "",
    "Models": "",
    "NewModelRelated": "",
    "NewStyleMaintenance": "",
    "Order": "",
    "OrderAverageDeliveryTime": "",
    "OrderDeliveryTimeDetail": "",
    "OrderDeliveryTimeOverview": "",
    "OrderIntake": "",
    "OrderStatus": "",
    "Performance": "",
    "Photos": "",
    "Price": "",
    "PriceParent": "",
    "ProductRecommendation": "",
    "Report": "",
    "ReportEight": "",
    "ReportEleven": "",
    "ReportFive": "",
    "ReportFour": "",
    "ReportNine": "",
    "ReportOne": "",
    "ReportSeven": "",
    "ReportSix": "",
    "ReportTen": "",
    "ReportThree": "",
    "ReportTwenty": "",
    "ReportTwentyV2": "",
    "ReportTwo": "",
    "RevenueReport": "",
    "SKU": "",
    "SalesReports": "",
    "Seats": "",
    "SpecificationRelationship": "",
    "Styles": "",
    "ToDoReminder": "",
    "TotalCommitments": "",
    "Travel": "",
    "TravelTabs": "",
    "Video": "",
    "Videos": "",
    "achievement": "",
    "cart": "",
    "competingGoods": "",
    "competitors": "",
    "createdAccount": "",
    "exhibition": "",
    "index": "",
    "lmageVideo": "",
    "loginlog": "",
    "modelsManager": "",
    "mwhCompetitorFeatures": "",
    "newCP": "",
    "newCompetions": "",
    "newPrices": "",
    "others": "",
    "poList": "",
    "qsInventory": "",
    "qsReport": "",
    "SalesAnalysis": "",
    "quotationSheet": "",
    "rai": "",
    "relatingPrices": "",
    "resetPassword": "",
    "tableList": "",
    "tableListbyCustomer": "",
    "usCP": "",
    "productInfo": "",
    "rankInfo": "",
    "Product": "",
    "vpsalesMezzanine": ""
  },
  "menusObj": {
    "menu_title1": "",
    "menu_title10": "",
    "menu_title11": "",
    "menu_title12": "",
    "menu_title13": "",
    "menu_title14": "",
    "menu_title15": "",
    "menu_title16": "",
    "menu_title17": "",
    "menu_title2": "",
    "menu_title3": "",
    "menu_title4": "",
    "menu_title5": "",
    "menu_title6": "",
    "menu_title7": "",
    "menu_title8": "",
    "menu_title9": ""
  },
  "model": "",
  "modelStatus": {
    "dropped": "",
    "newCover": "",
    "newModel": "",
    "phasedOut": "",
    "running": ""
  },
  "modifyPassword": "",
  "newPassword": "",
  "newPriceList": {
    "Comments": "",
    "Created": "",
    "Link": "",
    "Rep": "",
    "Updated": "",
    "columns1": "",
    "columns2": "",
    "columns3": "",
    "columns4": "",
    "createdPricelist": "",
    "entries": "",
    "pricelistForm": "",
    "title1": "",
    "typeToFilter": ""
  },
  "no": "",
  "noMore": "",
  "oldPassword": "",
  "order": {
    "Division": "",
    "Market": "",
    "PleaseEnterTheSearchKeyword": ""
  },
  "others": {
    "DFSEDIInvolce": {
      "EDIFileName": "",
      "ExportEDIFile": "",
      "ExportPOFile": "",
      "lnvoiceCode": ""
    }
  },
  "pageTitle": {
    "CompetitiveProductAnalysis": "",
    "Customer": "",
    "CustomerDet": "",
    "Order": "",
    "OrderStatus": "",
    "TravelList": ""
  },
  "passwordNoChange": "",
  "passwordRequirements": "",
  "price": {
    "Current": "",
    "From": {
      "Arms": "",
      "Close": "",
      "Construction": "",
      "CountryOfOrigin": "",
      "CreateModel": "",
      "ModelForm": "",
      "Name": "",
      "Remarks": "",
      "Style": "",
      "Unique": ""
    },
    "NewModel": "",
    "TypeToFilter": "",
    "addtoTheOriginalCombination": "",
    "combinationName": "",
    "createNewCombination": "",
    "modifyFunctionName": "",
    "modifyTheCombinationName": "",
    "table": {
      "Arms": "",
      "Backs": "",
      "Brand": "",
      "Categories": "",
      "Collections": "",
      "Current": "",
      "Features": "",
      "Image": "",
      "Mechanisms": "",
      "Model": "",
      "Remarks": "",
      "Seats": "",
      "Styles": "",
      "handle": "",
      "noPic": ""
    }
  },
  "prices": {
    "CoverGrade": "",
    "CoverType": "",
    "Cube": "",
    "Cubes": "",
    "Depth": "",
    "Depths": "",
    "Edit": "",
    "Function": "",
    "MaterialClass": "",
    "MaterialInfo": "",
    "MotionType": "",
    "PieceCount": "",
    "PowerClass": "",
    "Type": "",
    "addNewPriceSheet": "",
    "addPriceSheet": "",
    "addToPriceSheet": "",
    "allPrice": "",
    "back": "",
    "category": "",
    "change": "",
    "chooseCover": "",
    "clickPreview": "",
    "cnP": "",
    "description": "",
    "errorTip": "",
    "errorTips": "",
    "exportPriceSheet": "",
    "factory": "",
    "height": "",
    "heights": "",
    "length": "",
    "lengths": "",
    "multipleSelection": "",
    "newPriceList": "",
    "noPic": "",
    "priceEnd": "",
    "priceLists": "",
    "priceSheetColorNum": "",
    "priceSheetFileName": "",
    "priceSheetName": "",
    "priceStart": "",
    "priceTickets": "",
    "priceValidity": "",
    "pricesImportTemplate": "",
    "quoteLabel": "",
    "quoteRequired": "",
    "quoteSheet": "",
    "radio1": "",
    "radio2": "",
    "radio3": "",
    "rawPic": "",
    "sceneGraph": "",
    "search": "",
    "selectPic": "",
    "specificationNum": "",
    "style": "",
    "titleInfo": "",
    "vietnamP": "",
    "view": "",
    "viewPriceSheet": "",
    "viewOrderList": "",
    "viewInfo": ""
  },
  "productRecommendation": {
    "Division": "",
    "businessId": "",
    "businessName": "",
    "category": "",
    "color": "",
    "customer": "",
    "exportProductRecommendationScheme": "",
    "exportProductRecommendationTable": "",
    "exportProductRecommendationTemplate": "",
    "fabric": "",
    "followRecords": "",
    "functionFeatures": "",
    "importProductRecommendationTableInformation": "",
    "level": "",
    "material": "",
    "model": "",
    "price": "",
    "recommendedPriority": "",
    "recommendedReason": "",
    "required": "",
    "size": "",
    "specification": "",
    "style": "",
    "vpSales": ""
  },
  "psdiv": "",
  "report20": {
    "CRL": "",
    "FOBPrice": "",
    "Fabric": "",
    "LandedPrice": "",
    "RetailPrice": "",
    "classification": "",
    "floorSlot": "",
    "fobPrice": "",
    "leather": "",
    "mwSlot": "",
    "picture": "",
    "rank": "",
    "storeNumber": "",
    "suppliers": "",
    "total": ""
  },
  "reportItem": {
    "ItemTitle1": "",
    "ItemTitle10": "",
    "ItemTitle11": "",
    "ItemTitle2": "",
    "ItemTitle3": "",
    "ItemTitle4": "",
    "ItemTitle5": "",
    "ItemTitle6": "",
    "ItemTitle7": "",
    "ItemTitle8": "",
    "ItemTitle9": "",
    "Title": ""
  },
  "reportpage1": {
    "Ccode": "",
    "Cname": "",
    "NTitle1": "",
    "NTitle2": "",
    "NTitle3": "",
    "NTitle4": "",
    "NTitle5": "",
    "VPname": "",
    "title1": "",
    "title2": "",
    "title3": "",
    "title4": "",
    "title5": "",
    "title6": ""
  },
  "reportpage10": {
    "search": {
      "title1": "",
      "title2": "",
      "title3": "",
      "title4": ""
    },
    "thTitle": {
      "title1": "",
      "title10": "",
      "title11": "",
      "title12": "",
      "title13": "",
      "title14": "",
      "title15": "",
      "title16": "",
      "title17": "",
      "title18": "",
      "title19": "",
      "title2": "",
      "title20": "",
      "title21": "",
      "title22": "",
      "title23": "",
      "title3": "",
      "title4": "",
      "title5": "",
      "title6": "",
      "title7": "",
      "title8": "",
      "title9": ""
    },
    "tips1": "",
    "tips2": "",
    "tips3": "",
    "tips4": "",
    "fieldA": "",
    "fieldB": ""
  },
  "reportpage11": {
    "search": {
      "title1": "",
      "title2": "",
      "title3": "",
      "title4": ""
    },
    "thTitle": {
      "title1": "",
      "title10": "",
      "title11": "",
      "title12": "",
      "title2": "",
      "title3": "",
      "title4": "",
      "title5": "",
      "title6": "",
      "title7": "",
      "title8": "",
      "title9": ""
    },
    "tips1": "",
    "tips2": "",
    "tips3": "",
    "tips4": ""
  },
  "reportpage2": {
    "Ccode": "",
    "Cname": "",
    "days": "",
    "title1": "",
    "title2": "",
    "title3": "",
    "title4": "",
    "title5": "",
    "title6": ""
  },
  "reportpage4": {
    "Ccode": "",
    "ChassisFee": "",
    "ChassisSplit": "",
    "Cname": "",
    "CustomsExam": "",
    "Demurrage": "",
    "DropPickUpFee": "",
    "ECD": "",
    "OverTimeWaiting": "",
    "PrePull": "",
    "Totalcost": "",
    "YardStorage": ""
  },
  "reportpage5": {
    "ECDDTR": "",
    "PI": "",
    "actuallyFinishedDate": "",
    "amercement": "",
    "between120and150days": "",
    "between150and180days": "",
    "between15and30days": "",
    "between30and60days": "",
    "between60and90days": "",
    "between90and120days": "",
    "closingDate": "",
    "color": "",
    "csr": "",
    "customerCode": "",
    "customerName": "",
    "customerPO": "",
    "day": "",
    "dept": "",
    "eta": "",
    "etd": "",
    "finishedDay": "",
    "finishedGoodsInventoryAgeReport": "",
    "finishedGoodsInventoryInformationReport": "",
    "fob": "",
    "hasSolution": "",
    "incoterms": "",
    "inventory": "",
    "lessThan15days": "",
    "material": "",
    "model": "",
    "more60Days": "",
    "openingDate": "",
    "orderAmount": "",
    "orderWithSO": "",
    "orderWithoutSO": "",
    "ordersWithSO": "",
    "ordersWithoutSO": "",
    "over180days": "",
    "qty": "",
    "so": "",
    "soFalse": "",
    "soStatus": "",
    "soTrue": "",
    "solution": "",
    "spec": "",
    "stockDays": "",
    "stockDaysScope": "",
    "totalOrders": "",
    "tradeTerms": "",
    "tradeTerms2": "",
    "unit": "",
    "vbeln": "",
    "viewScope": "",
    "vpAssistance": "",
    "zjsi": ""
  },
  "reportpage8_7": {
    "Cname": "",
    "Country": "",
    "TradeTerms1": "",
    "TradeTerms2": "",
    "code": "",
    "ctn": "",
    "dept": "",
    "name": "",
    "title0": "",
    "title1": "",
    "title2": "",
    "title3": "",
    "title4": "",
    "title5": "",
    "title6": "",
    "title7": "",
    "title8": "",
    "title9": ""
  },
  "reportpage9": {
    "search": {
      "title1": "",
      "title2": "",
      "title3": "",
      "title4": "",
      "title5": ""
    },
    "thTitle": {
      "title1": "",
      "title2": "",
      "title3": "",
      "title4": "",
      "title5": "",
      "title6": ""
    },
    "tips1": "",
    "tips2": "",
    "tips3": "",
    "tips4": "",
    "tips5": "",
    "tips6": "",
    "tips7": "",
    "tips8": ""
  },
  "resetPassword": {
    "confirmReset": "",
    "pleaseEnterUsername": "",
    "reset": "",
    "resetSuccess": "",
    "tip": "",
    "username": "",
    "tips": ""
  },
  "saleBudget": {
    "Account": "",
    "apaSalesBudget": "",
    "year": "",
    "yearPlaceholder": "",
    "Baddress": "",
    "CDR": "",
    "CDRD": "",
    "Tariff": "",
    "VPdiscountRate": "",
    "ae": "",
    "bac": "",
    "bbi": "",
    "bc": "",
    "bi": "",
    "bn": "",
    "budgetLabel": "",
    "budgetQuota": "",
    "budgetYear": "",
    "bv": "",
    "cas": "",
    "cass": "",
    "cfab": "",
    "cfo": "",
    "ci": "",
    "clci": "",
    "cpu": "",
    "crsim": "",
    "customerCode": "",
    "customerName": "",
    "customerType": "",
    "dcn": "",
    "de": "",
    "dr": "",
    "fr": "",
    "fsp": "",
    "fti": "",
    "mfs": "",
    "month": "",
    "monthMap": {
      "10": "",
      "11": "",
      "12": "",
      "01": "",
      "02": "",
      "03": "",
      "04": "",
      "05": "",
      "06": "",
      "07": "",
      "08": "",
      "09": ""
    },
    "nbv": "",
    "nolp": "",
    "oftf": "",
    "osic": "",
    "project": "",
    "qc": "",
    "salesAmount": "",
    "salesBudget": "",
    "sta": "",
    "summary": "",
    "tdr": "",
    "tm": "",
    "tnr": "",
    "usaCountry": "",
    "vpSales": "",
    "wm": "",
    "yoyGrowth": "",
    "ysbr": "",
    "ysdrRate": ""
  },
  "timeOptions": {
    "endPlaceholder": "",
    "oneMonthAgo": "",
    "sixMonthAgo": "",
    "startPlaceholder": "",
    "threeMonthAgo": "",
    "today": ""
  },
  "travel": {
    "TravelSchedule": "",
    "agree": "",
    "approval": "",
    "approvalComments": "",
    "approvalDataExists": "",
    "approvalList": "",
    "approvalProcessPlanning": "",
    "approvalStatus": "",
    "approved": "",
    "approverComments": "",
    "businessCard": "",
    "company": "",
    "competitorStyle": "",
    "competitors": "",
    "country": "",
    "customerDetail": "",
    "customerName": "",
    "customerNameInput": "",
    "customerType": "",
    "date": "",
    "detail": "",
    "exportReport": "",
    "face": "",
    "followUp": "",
    "followUpInput": "",
    "fullAddress": "",
    "fullAddressInput": "",
    "generalManagerApproval": "",
    "img": "",
    "file": "",
    "location": "",
    "month": "",
    "mwStyle": "",
    "mwStyleInput": "",
    "visitor": "",
    "visitorInput": "",
    "position‌": "",
    "position‌Input": "",
    "contact": "",
    "contactInput": "",
    "recorder": "",
    "recorderInput": "",
    "followDate": "",
    "new": "",
    "old": "",
    "nopwaoabt": "",
    "notBeEmpty": "",
    "orders": "",
    "ordersInput": "",
    "other": "",
    "office": "",
    "Warehouse": "",
    "payment": "",
    "paymentInput": "",
    "pendingApproval": "",
    "pendingReview": "",
    "pendingSubmission": "",
    "placementNum": "",
    "prospectVisitTargets": "",
    "ptnopt": "",
    "quality": "",
    "qualityInput": "",
    "recall": "",
    "reject": "",
    "reject1": "",
    "rejected": "",
    "remark": "",
    "retailPrice": "",
    "reviewComments": "",
    "scheduledEndTime": "",
    "scheduledStartTime": "",
    "shipping": "",
    "shippingInput": "",
    "shop": "",
    "state": "",
    "storeNum": "",
    "storeNumInput": "",
    "storeStyle": "",
    "storeStyleInput": "",
    "submitForApproval": "",
    "tDays": "",
    "tel": "",
    "tips": "",
    "tips1": "",
    "title": "",
    "tnop": "",
    "tnopwhnt": "",
    "travelName": "",
    "travelPlan": "",
    "travelVPAssistant": "",
    "travelVPSales": "",
    "tvn": "",
    "view": "",
    "viewCompetitor": "",
    "visitCustomer": "",
    "visitMode": "",
    "visitResult": "",
    "visitResults": "",
    "visitTime": "",
    "vpAssistant": "",
    "year": "",
    "pleaseTravel": ""
  },
  "x": "",
  "types": "",
  "uploadDocuments": "",
  "util": {
    "CopySuccess": "",
    "ImageAddedtoEmail": "",
    "ImageAlreadyInEmail": "",
    "disableEmail": "",
    "disableSap": ""
  },
  "lineup": {
    "template": ""
  },
  "modelDetail": {
    "pd": ""
  },
  "ex": {
    "businessCard": "",
    "attachment": ""
  },
  "qs": {
    "cs": ""
  },
  "commitments": {
    "detailInfo": "",
    "exportOrderUpdateInfo": "",
    "summaryInfo": ""
  },
  "tips": {
    "resp1": ""
  },
  "export": {
    "labelType": "",
    "labelTypes": ""
  },
  "qsReport": {
    "customerCode": "",
    "customerName": "",
    "intake": "",
    "shipment": "",
    "yoyI": "",
    "yoyS": "",
    "IS": "",
    "TIS": ""
  },
  "salesAnalysis": {
    "model": "",
    "floor": "",
    "color": "",
    "catagory": "",
    "pb": "",
    "xse": "",
    "orderInTakeNum": "",
    "threeMonths": "",
    "growth": "",
    "Accumulated": "",
    "PCS": "",
    "Category": "",
    "qty": "",
    "qtyRate": "",
    "amount": "",
    "salesAmount": "",
    "amountRate": "",
    "level": "",
    "spec": "",
    "rate": "",
    "materialAnalysis": "",
    "levelAnalysis": "",
    "categoryAnalysis": "",
    "deliveryDate": "",
    "invoicing Date": "",
    "exportTips": "",
    "exportTipsTwo": ""
  },
  "productInfo": {
    "category": "",
    "rankings": "",
    "sixMonths": ""
  }
};
